const FETCH_RATINGS = 'estadisticas/reputation/FETCH_RATINGS';
const FETCH_RATINGS_COMPLETED = 'estadisticas/reputation/FETCH_RATINGS_COMPLETED';
const FETCH_RATINGS_FAILED = 'estadisticas/reputation/FETCH_RATINGS_FAILED';
const FETCH_QUALITY = 'estadisticas/reputation/FETCH_QUALITY';
const FETCH_QUALITY_COMPLETED = 'estadisticas/reputation/FETCH_QUALITY_COMPLETED';
const FETCH_QUALITY_FAILED = 'estadisticas/reputation/FETCH_QUALITY_FAILED';
const FETCH_REPORTS = 'estadisticas/reputation/FETCH_REPORTS';
const FETCH_REPORTS_COMPLETED = 'estadisticas/reputation/FETCH_REPORTS_COMPLETED';
const FETCH_REPORTS_FAILED = 'estadisticas/reputation/FETCH_REPORTS_FAILED';

export {
  FETCH_RATINGS,
  FETCH_RATINGS_COMPLETED,
  FETCH_RATINGS_FAILED,
  FETCH_QUALITY,
  FETCH_QUALITY_COMPLETED,
  FETCH_QUALITY_FAILED,
  FETCH_REPORTS,
  FETCH_REPORTS_COMPLETED,
  FETCH_REPORTS_FAILED
};
